import { toastSuccessMessage } from "../../../../utils/alerts";

import { PageOutcomeScore } from "components/outcomes/PageOutcomeScore";
import { RubricList } from "components/outcomes/RubricList";
import { displayOutcomeName } from "components/outcomes/helpers";
import { OutcomeAssessmentType } from "components/server-types";
import { t } from "i18n/i18n";
import { ExpandableText } from "mds/components/ExpandableText";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { TrashDeleteIcon } from "mds/icons";
import { storeApi, useAppSelector } from "store/index";
import {
  NestedPageOutcomeType,
  selectNestedPageOutcomes,
  selectPageOutcomeRubric,
} from "store/selectors";
import { ErrorBoundary } from "worksheets/views/ErrorBoundary";

export const PageOutcomeRubric = ({
  className,
  pageOutcome,
  disabled = false,
  outcomeAssessment,
  canModify = false,
}: {
  className?: string;
  pageOutcome: NestedPageOutcomeType;
  outcomeAssessment?: OutcomeAssessmentType;
  canModify?: boolean;
  disabled?: boolean;
}) => {
  const rubric = useAppSelector((s) => selectPageOutcomeRubric(s, pageOutcome.id));
  const pageOutcomes = useAppSelector((s) => selectNestedPageOutcomes(s, pageOutcome.page_id));
  const onDeletePageOutcome = () => {
    storeApi.page_outcomes.destroy(pageOutcome.id).then(() => {
      if (pageOutcomes.filter((po) => po.id !== pageOutcome.id).length === 0) {
        toastSuccessMessage(t("success.toasts.deleted_last_page_outcome"));
      }
    });
  };

  return (
    <div className={className} key={pageOutcome.outcome.title}>
      <div className="mb-2 flex items-center justify-between gap-2">
        <PageOutcomeScore className="" pageOutcome={pageOutcome} />
        {canModify && (
          <SquareIconButton
            aria-label={t("common.remove_item", {
              item: displayOutcomeName(pageOutcome.outcome),
            })}
            disabled={disabled}
            eventName="Page Outcome - Delete"
            eventProps={{ outcome: pageOutcome.outcome.title }}
            kind="caution"
            size="s"
            onClick={onDeletePageOutcome}
          >
            <TrashDeleteIcon />
          </SquareIconButton>
        )}
      </div>

      <ExpandableText className="flex-none">{pageOutcome.outcome.description}</ExpandableText>

      <ErrorBoundary>
        <RubricList
          className="flex flex-none flex-col gap-1"
          outcomeAssessment={outcomeAssessment}
          outcomeItem={pageOutcome}
          readOnly={!canModify || disabled}
          rubric={rubric}
          showHeader={false}
        />
      </ErrorBoundary>
    </div>
  );
};
